import { render, staticRenderFns } from "./chat-inbox.vue?vue&type=template&id=574ebcab&scoped=true&"
import script from "./chat-inbox.vue?vue&type=script&lang=js&"
export * from "./chat-inbox.vue?vue&type=script&lang=js&"
import style0 from "./chat-inbox.vue?vue&type=style&index=0&id=574ebcab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ebcab",
  null
  
)

export default component.exports